import {PagedListResponse} from '../models/paged-list-response';

function hasNextPage(response: PagedListResponse<any>): boolean {
  if (response.CountRecords === 0 ||
    response.PageSize === 0 ||
    response.Data === null ||
    response.Data.length === 0)
    return false;
  return ((response.CurrentPage + 1) * response.PageSize < response.CountRecords);
}

function hasPreviousPage(response: PagedListResponse<any>): boolean {
  return response.CurrentPage > 0;
}

function startIndex(response: PagedListResponse<any>): number {
  const expected = response.CurrentPage * response.PageSize + 1;
  return Math.min(expected, response.CountRecords);
}

function endIndex(response: PagedListResponse<any>): number {
  const expected = (response.CurrentPage + 1) * response.PageSize;
  return Math.min(expected, response.CountRecords);
}

class PagedListResponseUtilsClass {
  readonly hasNextPage = hasNextPage;
  readonly hasPreviousPage = hasPreviousPage;
  readonly startIndex = startIndex;
  readonly endIndex = endIndex;
}

export const pagedListResponseUtils = new PagedListResponseUtilsClass();
